import { createStore, createStateHook, createActionsHook } from 'react-sweet-state';
import type { Action, StoreActionApi } from 'react-sweet-state';

import type { ActiveContent } from '@atlassian/ai-audio';

type AudioButtonWrapperState = {
	activeContent: ActiveContent | null;
};

const initialState: AudioButtonWrapperState = {
	activeContent: null,
};

type AudioButtonWrapperActions = {
	setActiveContent: (
		activeContent: ActiveContent | null,
	) => Action<AudioButtonWrapperState, void, void>;
};

const actions: AudioButtonWrapperActions = {
	setActiveContent:
		(activeContent: ActiveContent | null) =>
		({ setState }: StoreActionApi<AudioButtonWrapperState>) => {
			return setState({ activeContent });
		},
};

const AudioButtonWrapperStore = createStore<AudioButtonWrapperState, AudioButtonWrapperActions>({
	name: 'AudioButtonWrapperStore',
	initialState,
	actions,
});

export const useAudioButtonWrapperStore = createStateHook(AudioButtonWrapperStore, {
	selector: (state) => ({ activeContent: state.activeContent }),
});

export const useAudioButtonWrapperActions = createActionsHook(AudioButtonWrapperStore);
